import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootEl = document.getElementById('root') as HTMLElement;

if (rootEl.hasChildNodes()) {
  // Hydrate static HTML pre-rendered by react-snap
  ReactDOM.hydrateRoot(rootEl, <React.StrictMode><App /></React.StrictMode>);
} else {
  ReactDOM.createRoot(rootEl).render(<React.StrictMode><App /></React.StrictMode>);
}

reportWebVitals();
